import { types as userRdcTypes } from '@saucelabs/sl-module-user-rdc';

import * as constants from './../constants';

const initialState = null;

const rdcErrorReducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case constants.INITIAL_DATA.FAILURE:
    case constants.MOBILE_APPS_FETCH.FAILURE:
    case constants.MOBILE_AVAILABLE_DEVICE_IDS_FETCH.FAILURE:
    case constants.MOBILE_DEVICES_FETCH.FAILURE:
    case constants.MOBILE_SESSION_APP_VERSIONS_FETCH.FAILURE:
    case constants.MOBILE_SESSION_APP_VERSION_FETCH.FAILURE:
    case constants.MOBILE_SESSION_AVAILABLE_FETCH.FAILURE:
    case userRdcTypes.RDC_SIGNUP.FAILURE:
    case userRdcTypes.SUBSCRIPTION_RDC_GET.FAILURE:
    case userRdcTypes.WHOAMI_RDC_GET.FAILURE: {
      const { response: { data, status } } = payload;

      return {
        code: status,
        serverMessage: data,
      };
    }
    case constants.INITIAL_DATA.SUCCESS:
    case constants.MOBILE_APPS_FETCH.SUCCESS:
    case constants.MOBILE_AVAILABLE_DEVICE_IDS_FETCH.SUCCESS:
    case constants.MOBILE_DEVICES_FETCH.SUCCESS:
    case constants.MOBILE_SESSION_APP_VERSIONS_FETCH.SUCCESS:
    case constants.MOBILE_SESSION_APP_VERSION_FETCH.SUCCESS:
    case constants.MOBILE_SESSION_AVAILABLE_FETCH.SUCCESS:
    case userRdcTypes.RDC_SIGNUP.SUCCESS:
    case userRdcTypes.SUBSCRIPTION_RDC_GET.SUCCESS:
    case userRdcTypes.WHOAMI_RDC_GET.SUCCESS:
      return initialState;
    default:
      return state;
  }
};

export default rdcErrorReducer;
export { initialState };
